module.exports = __webpack_public_path__ + "img/catalogGarden.271c59a1.jpg";